import styled from 'styled-components'

export const Container = styled.div`
  .row:not(:last-child) {
    margin-bottom: 0.3rem;
  }
`
